import * as actionTypes from "../actions/actionTypes";
import { updateObject } from "../../shared/utility";

const initialState: {
  balanceBillingHistoryForUser: {
    claimId: number;
    procedureLabel: string;
    patientName: string;
    dateOfService: string;
    facility: string;
    added: string;
    status: string;
  }[];
  error: boolean;
  loading: boolean;
} = {
  balanceBillingHistoryForUser: [],
  error: false,
  loading: false,
};
const fetchBalanceBillingHistoryForUser = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_BALANCE_BILLING_HISTORY_FOR_USER_SUCCESS: {
      console.log(
        "action.balanceBillingHistoryForUser",
        action.balanceBillingHistoryForUser
      );
      return updateObject(state, {
        balanceBillingHistoryForUser: action.balanceBillingHistoryForUser,
        error: false,
        loading: false,
      });
    }
    case actionTypes.FETCH_BALANCE_BILLING_HISTORY_FOR_USER_STARTED:
      return updateObject(state, {
        balanceBillingHistoryForUser: initialState.balanceBillingHistoryForUser,
        error: false,
        loading: true,
      });

    case actionTypes.FETCH_BALANCE_BILLING_HISTORY_FOR_USER_FAILED:
      return updateObject(state, {
        balanceBillingHistoryForUser: initialState.balanceBillingHistoryForUser,
        error: true,
        loading: false,
      });

    default:
      return state;
  }
};

export default fetchBalanceBillingHistoryForUser;
